import React, { useState, useEffect, useCallback } from 'react'
import { useAuthContext } from 'contexts/Auth'
import { Button, Checkbox, Col, Form, Input, Row, Select, Space, Tooltip, Typography } from 'antd'
import { CopyOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'
import axios from 'axios';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PDF from './PDF';
import feeTypes from 'data/feeTypes.json'

const { Title, Text } = Typography

const initialState = { registrationNumber: "", cnic: "", email: "", fullName: "", phone: "", isSendSMS: false, whatsapp: "", courseId: "", course: {}, amount: 0, feeType: null, remarks: "" }

export default function Add({ application, setApplications, applications }) {

    const { getApiConfig } = useAuthContext()

    const [isNew, setIsNew] = useState(true)
    const [state, setState] = useState(initialState)
    const [isProcessing, setIsProcessing] = useState(false)
    const [pdfData, setPdfData] = useState({})

    const params = useParams()

    const handleChange = e => setState(s => ({ ...s, [e.target.name]: e.target.value }))
    const handleChangeSelect = (name, value) => setState(s => ({ ...s, [name]: value }))

    const readDocument = useCallback(async () => {
        if (params.id !== "add" && !application) {
            axios.get(`${window.api}/transactions/single?registrationNumber=${params.id}`, getApiConfig())
                .then((res) => {
                    const { data, status } = res
                    if (status === 200) {
                        setState(s => ({ ...s, ...data.transaction }))
                        setIsNew(false)
                    }
                })
                .catch(error => {
                    console.error(error)
                    window.toastify(error.response?.data?.message || "Something went wrong while getting the transaction", "error")
                })
        } else {
            setState(initialState)
            setIsNew(true)
        }
    }, [params.id, application, getApiConfig])
    useEffect(() => { readDocument() }, [readDocument])

    const readApplication = useCallback(async () => {
        let registrationNumber = state.registrationNumber
        if (registrationNumber.length < 12) { return window.toastify("Please enter registration number correctly", "error") }
        registrationNumber = registrationNumber.toUpperCase()
        axios.get(`${window.api}/applications/single-with-registrationNumber/${registrationNumber}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    setState(s => ({ ...s, ...data.application }))
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while getting the application", "error")
            })
    }, [state.registrationNumber, getApiConfig])

    useEffect(() => {
        if (application) {
            const { registrationNumber, cnic, email, fullName, phone, isSendSMS, whatsapp, courseId, course = {} } = application
            setState({ registrationNumber, cnic, email, fullName, phone, isSendSMS, whatsapp, courseId, course, amount: course.netFee })
        }
    }, [application])

    const handleSubmit = e => {
        e.preventDefault()

        let { registrationNumber, cnic, email, fullName, phone, isSendSMS, whatsapp, courseId, amount, feeType, remarks } = state

        registrationNumber = registrationNumber.trim()
        cnic = window.getValidCNIC(cnic)
        fullName = fullName.trim()
        phone = phone.trim()
        whatsapp = whatsapp.trim()
        amount = Number(amount)

        if (registrationNumber.length < 12) { return window.toastify("Please enter registration number correctly", "error") }
        if (cnic.length !== 13) { return window.toastify('Please enter CNIC / B-form correctly', "error") }
        if (!window.isEmail(email)) { return window.toastify('Please enter a valid email address', "error") }
        if (fullName.length < 3) { return window.toastify("Please enter student full name correctly", "error") }
        if (!phone) { return window.toastify('Please enter phone number', "error") }
        if (phone.charAt(0) === "0" || whatsapp.charAt(0) === "0") { return window.toastify("Phone number or WhatsApp can't be start with 0. Please start it with country code", "error") }
        if (phone.slice(0, 2) === "92" && phone.length !== 12) { return window.toastify("Please enter phone number correctly", "error") } // Only for Pakistan
        if (!whatsapp) { return window.toastify('Please enter whatsapp number', "error") }
        if (whatsapp.slice(0, 2) === "92" && whatsapp.length !== 12) { return window.toastify("Please enter whatsapp number correctly", "error") } // Only for Pakistan
        if (!courseId) { return window.toastify('Please select course', "error") }
        if (amount < 1) { return window.toastify('Please enter amount correctly', "error") }
        if (!feeType) { return window.toastify('Please select fee type', "error") }

        let formData = { registrationNumber, cnic, email, fullName, phone, isSendSMS, whatsapp, courseId, amount, feeType, remarks }

        setIsProcessing(true)
        createDocument(formData)
    }

    const createDocument = async (formData) => {

        axios[isNew ? "post" : "patch"](`${window.api}/transactions/${isNew ? "add" : `update/${state.id}`}`, formData, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === isNew ? 201 : 200) {
                    window.toastify(data.message, "success")
                    setPdfData(data.transaction)

                    if (application.id) {
                        const updateDocs = applications.map((doc) => {
                            if (doc.id === application.id)
                                return { ...doc, status: "confirmed", payment: "received" }
                            return doc
                        })
                        setApplications(updateDocs)
                    }
                    // console.log('data.transaction', data.transaction)
                    // if (formData.isSendSMS) {
                    //     sendSMS(formData)
                    // }
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || `Something went wrong while ${isNew ? "completing the" : "updating the"} transaction`, "error")
            })
            .finally(() => {
                setIsProcessing(false)
            })
    }

    // const sendSMS = async (formData) => {

    //     let { fullName, phone, amount, feeType } = formData

    //     let msg = `Dear ${fullName}, This is a confirmation that we have just received your ${feeType?.label} PKR ${amount}. Thank you!`

    //     const { REACT_APP_TELENOR_API_END_POINT, REACT_APP_TELENOR_LOGIN_ID, REACT_APP_TELENOR_LOGIN_PASSWORD } = process.env
    //     let sessionId;
    //     await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/auth.jsp?msisdn=${REACT_APP_TELENOR_LOGIN_ID}&password=${REACT_APP_TELENOR_LOGIN_PASSWORD}`)
    //         .then((res) => {
    //             sessionId = window.getDataFromHTML(res.data, "data");
    //         })
    //         .catch(err => {
    //             console.error(err)
    //             window.toastify("Something went wrong while getting session ID.", "error")
    //         })
    //     if (sessionId) {
    //         await axios.get(`${REACT_APP_TELENOR_API_END_POINT}/sendsms.jsp?session_id=${sessionId}&to=${phone}&text=${msg}&mask=AlSeeraht`)
    //             .then((res) => {
    //                 let status = window.getDataFromHTML(res.data, "response");
    //                 if (status === "OK") {
    //                     window.toastify("SMS successfully sent", "success")
    //                 } else {
    //                     window.toastify("SMS not sent", "error")
    //                 }
    //             })
    //             .catch(err => {
    //                 console.error(err)
    //                 window.toastify("Something went wrong, We couldn't send SMS. Please contact support team.", "error")
    //             })
    //     }
    //     // sendEmail(formData)
    // }

    // const sendEmail = (formData) => {

    //     let { student, amount, type } = formData
    //     let { fullName, phone } = student

    //     const url = `${window.origin}/auth/create-account/?email=${email}&id=${id}&fee=${fee.id}`
    //     let data = { ...formData, url, logo: window.logoURL }

    //     const URL = process.env.REACT_APP_API_END_POINT;

    //     const msg = {
    //         to: email,
    //         from: 'salaam@umairahmad.net',
    //         subject: `Invitation message from ${window.feeName}`,
    //         text: `Salaam ${fullName}`,
    //         html: "",
    //         data
    //     };
    //     axios.post(`${URL}/sendEmail`, msg)
    //         .then((res) => {
    //             if (res.data.type === "success") {
    //                 window.toastify("Email successfully sent", "success")
    //             } else {
    //                 window.toastify("Email not sent", "error")
    //                 console.error(res.data.error)
    //             }
    //         })
    //         .catch(err => {
    //             console.error(err)
    //             window.toastify("Something went wrong, We couldn't send email. Please contact support team.", "error")
    //         })
    // }

    const pdf = <PDF data={pdfData} />

    return (
        <>
            {!application && <Row className='mb-3'>
                <Col>
                    <Title level={3} className="mb-0">Fees</Title>
                </Col>
            </Row>
            }
            <Row gutter={16}>
                <Col span={24}>
                    <div className={!application ? "card" : ""}>
                        {!application && <Row className='mb-4'>
                            <Col>
                                <Title level={4} className="mb-0">Receive Fee</Title>
                            </Col>
                        </Row>
                        }
                        <Form layout='vertical'>
                            <Row gutter={16}>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Registration" required>
                                        <Input placeholder="Example (PTP-01-000001)" name="registrationNumber" value={state.registrationNumber} onChange={handleChange} onBlur={readApplication} disabled={application} />
                                        {state.course?.title && <Text className='position-absolute text-primary' style={{ top: 30, left: 2, fontSize: 12 }}><b>Course</b>:  {state.course?.title}</Text>}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="CNIC/B-Form" required>
                                        <Input maxLength={13} placeholder="Student CNIC / B-Form" name="cnic" value={state.cnic} onChange={handleChange} disabled />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Email" required>
                                        <Input placeholder="Email" name="email" value={state.email} onChange={handleChange} disabled />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Name" required>
                                        <Input placeholder="Student full name" name="fullName" value={state.fullName} onChange={handleChange} disabled />
                                    </Form.Item>
                                </Col>
                                {/* <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Course" required>
                                        <Select
                                            showSearch
                                            placeholder="Select a class"
                                            onChange={val => handleChangeSelect("courseId", val)}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={klasses}
                                            value={state.courseId}
                                        />
                                    </Form.Item>
                                </Col> */}
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Phone number" required>
                                        <Space.Compact className='w-100'>
                                            <PhoneInput country={'pk'} value={state.phone} onChange={phone => setState(s => ({ ...s, phone }))} inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                                            <Tooltip title="Send SMS">
                                                <Button className='p-0 px-2'><Checkbox checked={state.isSendSMS} onChange={e => setState(s => ({ ...s, isSendSMS: e.target.checked }))} /></Button>
                                            </Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="WhatsApp" required>
                                        <Space.Compact className='w-100'>
                                            <PhoneInput country={'pk'} value={state.whatsapp} onChange={whatsapp => setState(s => ({ ...s, whatsapp }))} inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                                            <Tooltip title="Copy Phone Number">
                                                <Button onClick={() => { setState(s => ({ ...s, whatsapp: s.phone })) }} icon={<CopyOutlined />} />
                                            </Tooltip>
                                        </Space.Compact>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Amount" required>
                                        <Input placeholder="Amount / Fee" name="amount" value={state.amount} onChange={handleChange} onKeyDown={window.onlyNumber} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Fee Type" required>
                                        <Select showSearch placeholder="Select a fee type" value={state.feeType} onChange={val => handleChangeSelect("feeType", val)} options={feeTypes} filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24}>
                                    <Form.Item label="Remarks">
                                        <Input.TextArea rows={2} className="resize-none" placeholder="Remarks if any" name="remarks" value={state.remarks} onChange={handleChange} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='text-end'>
                                    <Space size="small">
                                        {pdfData.id &&
                                            <PDFDownloadLink document={pdf} fileName={`${window.appName} Fee Receipt - ${pdfData.fullName}`}>
                                                {({ blob, url, loading, error }) => <Button type='primary' block loading={loading}>Download Form</Button>}
                                            </PDFDownloadLink>
                                        }
                                        <Button type='primary' loading={isProcessing} onClick={handleSubmit}>{isNew ? "Receive" : "Update"}</Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>
        </>
    )
}